import { Injectable } from '@angular/core';

import { delay, map, Observable, of } from 'rxjs';

import { GetPaginationRes } from '@pp/core/entities';

import { getCryptoMarketMock, getRatesMock, Rates } from './rate-conditions';
import { ShellApi } from './shell.api';
import { ApiSettings } from './shell.entities';

@Injectable()
export class ShellMockApi extends ShellApi {
  override getRates(): Observable<GetPaginationRes<Rates>> {
    const rates = getRatesMock() as Rates[];

    return of<GetPaginationRes<Rates>>({ items: rates }).pipe(delay(2000));
  }

  override getCryptoMarket(): Observable<GetPaginationRes<any>> {
    const cryptoMarketRates = getCryptoMarketMock();

    return of<GetPaginationRes<any>>({ items: cryptoMarketRates }).pipe(delay(2000));
  }

  override getTotalBalance(): Observable<string> {
    return of('0').pipe(delay(1000));
  }

  override getSettings(): Observable<ApiSettings> {
    return of({ agent_feature_availability: true, agent_feature_url: 'asdsads:asdas/asdasd' }).pipe(delay(1000));
  }

  override changeAgentFeatureAvailability(agent_feature_availability: boolean): Observable<void> {
    return of(agent_feature_availability).pipe(
      delay(1000),
      map(() => null),
    );
  }

  override generateTelegramLink(): Observable<string> {
    return of('https://t.me/pp_dev_support_bot').pipe(delay(1000));
  }
}
